module.exports = __webpack_public_path__ + "static/img/3s-platform-bg.da470dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-bg.png
// module id = tUr6
// module chunks = 0